var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMental01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2017 31.5C18.2017 31.5 21.5767 36 27.2017 36C32.8267 36 36.2017 31.5 36.2017 31.5M33.9517 20.25H33.9742M20.4517 20.25H20.4742M49.7017 27C49.7017 39.4264 39.6281 49.5 27.2017 49.5C14.7753 49.5 4.70166 39.4264 4.70166 27C4.70166 14.5736 14.7753 4.5 27.2017 4.5C39.6281 4.5 49.7017 14.5736 49.7017 27ZM35.0767 20.25C35.0767 20.8713 34.573 21.375 33.9517 21.375C33.3303 21.375 32.8267 20.8713 32.8267 20.25C32.8267 19.6287 33.3303 19.125 33.9517 19.125C34.573 19.125 35.0767 19.6287 35.0767 20.25ZM21.5767 20.25C21.5767 20.8713 21.073 21.375 20.4517 21.375C19.8303 21.375 19.3267 20.8713 19.3267 20.25C19.3267 19.6287 19.8303 19.125 20.4517 19.125C21.073 19.125 21.5767 19.6287 21.5767 20.25Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMental01);
export default __webpack_public_path__ + "static/media/mental01.5e43dcd03d3646ba2609636688542fe4.svg";
export { ForwardRef as ReactComponent };